import { Button, Grid, IconButton, useMediaQuery } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import { GlobalTable } from '../../utility/globalTable';
import { DataConnectorAssignment, DocumentListDataModel, dataConnectorAssignmentType, dataConnectorList } from '../../../models/axiosModel';
import moment from 'moment';
import GlobalPopUp from '../../utility/globalPopUp';
import DeleteDocumentDataComponent from './../deleteDocumentDataComponent';
import agent from '../../../services/api';
import AddIcon from '@mui/icons-material/Add';
import IconsColor from '../../utility/iconsColor';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import deleteDoc from "../../../assets/deleteDoc.svg";
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, chatbotIntegrationsBreadcrumb, customAPIBreadcrumb, homeBreadcrumb } from '../../../utils/breadcrumb';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import GlobalButton from '../../utility/globalButton/button';
import AssignDataConnectorPopup from './assignDataConnectorPopup';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../context/dataConnectorContext';
import { isSystemApi } from '../../../utils/constants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const Dataconnector = () => {

    let headerList = [
        {
            name: "Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "data_connector_function_name",
        },
        {
            name: "Description",
            alignment: "left",
            flagIcon: false,
            valueKey: "data_connector_function_description",
        },
        {
            name: "URL",
            alignment: "left",
            flagIcon: false,
            valueKey: "chatbot_data_connector_url",
        },
        {
            name: "Method Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "function_method_name",
        },
        {
            name: "",
            alignment: "right",
            flagIcon: true,
            valueKey: "",
            iconKey: "editIcon"
        },
    ]

    const navigate = useNavigate()

    const { userDetail, flagLoading, setFlagLoading, handleError} = useContext(UserContext) as UserContextPayload;
    const { getChatbotDataConnectorList, getDataConnectorAssignmentType, removeDataConnectorAssignment} = useContext(DataConnectorContext) as DataConnectorContextpayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [docDetailForTable, setDocDetailForTable] = useState<DocumentListDataModel[]>([])
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [adjustedHeaderList, setAdjustedHeaderList] = useState(headerList);
    const [adjustedDocDetailForTable, setAdjustedDocDetailForTable] = useState(docDetailForTable);
    const [flagDeleteDocumentDataPopup, setFlagDeleteDocumentDataPopup] = useState(false)
    const [documentSelected, setDocumentSelected] = useState<null | dataConnectorList>(null)
    const [rowAllowEdit, setRowAllowEdit] = useState(null);
    const [flagRenderData, setFlagRenderData] = useState<Boolean | null>(null);
    const [dataConnectorList, setDataConnectorList] = useState<dataConnectorList[]>([]); 
    // const [dataConnectorList, setDataConnectorList] = useState<dataConnectorList[]>([]);

    const [flagAssignDataConnectorPopup, setFlagAssignDataConnectorPopup] = useState<boolean>(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const { chatBotDetails, chatbotList, setChatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    const chatbotId = searchParams.get("chatbot_id") ?? (chatBotDetails ? chatBotDetails.chatbot_id : "") 

    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)');

    let pathname = window.location.pathname.toLowerCase(); 

    const dataConnectorListResObj = [
        {
            "chatbot_data_connector_id": 213,
            "chatbot_data_connector_url": "https://example.com/",
            "function_method_id": 2,
            "function_method_name": "GET",
            "data_connector_platform_assignment": [
              {
                "data_connector_platform_id": 2,
                "data_connector_platform_name": "Lead Generation",
                "data_connector_platform_assignment_id": 110,
                "chatbot_data_connector_id": "213"
              }
            ],
            "data_connector_assignment": [],
            "data_connector_functions": {
              "data_connector_function_id": 198,
              "data_connector_function_name": "Test Data Connector 6",
              "data_connector_asst_function_name": "testDataConnector6",
              "data_connector_function_description": "Test Data Connector"
            }
        },
        {
            "chatbot_data_connector_id": 211,
            "chatbot_data_connector_url": "https://example.com/",
            "function_method_id": 1,
            "function_method_name": "POST",
            "data_connector_platform_assignment": [
              {
                "data_connector_platform_id": 2,
                "data_connector_platform_name": "Lead Generation",
                "data_connector_platform_assignment_id": 118,
                "chatbot_data_connector_id": "211"
              }
            ],
            "data_connector_assignment": [
              {
                "data_connector_assignment_id": 22,
                "data_connector_assignment_type_id": 1,
                "chatbot_data_connector_id": 211,
                "data_connector_assignment_unique_id": 344,
                "created_at_timestamp": "2025-04-15T07:38:49.000Z",
                "updated_at_timestamp": null,
                "history_id": null,
                "added_by_change_log_id": 30846,
                "data_connector_assignment_flag_deleted": false,
                "data_connector_assignment_type_name": "Chatbot"
              },
              {
                "data_connector_assignment_id": 23,
                "data_connector_assignment_type_id": 1,
                "chatbot_data_connector_id": 211,
                "data_connector_assignment_unique_id": 339,
                "created_at_timestamp": "2025-04-15T07:40:11.000Z",
                "updated_at_timestamp": null,
                "history_id": null,
                "added_by_change_log_id": 30847,
                "data_connector_assignment_flag_deleted": false,
                "data_connector_assignment_type_name": "Chatbot"
              }
            ],
            "data_connector_functions": {
              "data_connector_function_id": 196,
              "data_connector_function_name": "New Test Data Connector updated",
              "data_connector_asst_function_name": "newTestDataConnectorUpdated",
              "data_connector_function_description": "Test Data Connector"
            }
        }, 
        {
            "chatbot_data_connector_id": 215,
            "chatbot_data_connector_url": "https://example.com/",
            "function_method_id": 3,
            "function_method_name": "DELETE",
            "data_connector_platform_assignment": [
              {
                "data_connector_platform_id": 2,
                "data_connector_platform_name": "Lead Generation",
                "data_connector_platform_assignment_id": 110,
                "chatbot_data_connector_id": "215"
              }
            ],
            "data_connector_assignment": [
              {
                "data_connector_assignment_id": 25,
                "data_connector_assignment_type_id": 1,
                "chatbot_data_connector_id": 215,
                "data_connector_assignment_unique_id": 344,
                "created_at_timestamp": "2025-04-15T07:38:49.000Z",
                "updated_at_timestamp": null,
                "history_id": null,
                "added_by_change_log_id": 30846,
                "data_connector_assignment_flag_deleted": false,
                "data_connector_assignment_type_name": "Chatbot"
              },
            ],
            "data_connector_functions": {
              "data_connector_function_id": 198,
              "data_connector_function_name": "Test Data Connector 123",
              "data_connector_asst_function_name": "testDataConnector6",
              "data_connector_function_description": "Test Data Connector"
            }
        },
    ]

    const getChatbotDataConnectorListApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await getChatbotDataConnectorList();

        // let temp = dataConnectorListResObj.filter((data: dataConnectorList) => data.data_connector_assignment.some((assignment: DataConnectorAssignment) => assignment.data_connector_assignment_unique_id == Number(chatbotId))).map((dataConnector: dataConnectorList) => ({ ...dataConnector, ...dataConnector.data_connector_functions }))
        // setDataConnectorList(temp)

        if (response.status && response.data) {
            const customAPIs = response.data.filter((data: dataConnectorList) => data.data_connector_assignment.some((assignment: DataConnectorAssignment) => assignment.data_connector_assignment_unique_id == Number(chatbotId))).map((dataConnector: dataConnectorList) => ({ ...dataConnector, ...dataConnector.data_connector_functions }))
            const updatedCustomAPI = customAPIs?.map((api) => {
                if(isSystemApi(api?.chatbot_data_connector_function_path)){
                    return {
                        ...api,
                        data_connector_function_description: "-",
                        chatbot_data_connector_url: "-",
                        function_method_name: "-",
                    }
                }
                return api;
            })
            setDataConnectorList(updatedCustomAPI)
        } else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    } 

    const getDataConnectorAssignmentTypeApi = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getDataConnectorAssignmentType();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    const isMobile = screenWidth <= 1200;

    useEffect(() => {
        if (userDetail.flagUser) {
            (async () => {
                setFlagRenderData(false)
                setFlagRenderData(true)
            })()
        }
    }, [])

    useEffect(() => {
        getChatbotDataConnectorListApiCall();
        getDataConnectorAssignmentTypeApi();
    }, [searchParams]);

    useEffect(() => {
        const updatedBreadcrumbs = [
            {...homeBreadcrumb}, 
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbotId}`},
            {...chatbotIntegrationsBreadcrumb, path: `/chatbot/viewchatbot/integration?chatbot_id=${chatbotId}`}, 
            {...customAPIBreadcrumb, isActive: true},
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    useEffect(() => {
        if (isMobile) {
            // For mobile view
            const filteredHeaderList = headerList.filter(header => header.name !== "Category");
            const modifiedHeaderList = filteredHeaderList.map(header => {
                if (header.name === "Documents") {
                    return { ...header, flagIcon: false };
                }
                if (header.name === "Date and time") {
                    return { ...header, name: "Last Modified" };
                }
                return header;
            });

            setAdjustedHeaderList(modifiedHeaderList);
            docDetailForTable.slice(0, 10).map((row: any) => {
                row[`formatted_timestamp`] = moment(row.updated_at_timestamp).format('DD-MM-YY HH:mm')
            })
            setAdjustedDocDetailForTable(docDetailForTable);
        } else {
            // For desktop view
            setAdjustedHeaderList(headerList);
            docDetailForTable.slice(0, 10).map((row: any) => {
                row[`formatted_timestamp`] = moment(row.updated_at_timestamp).format('DD-MM-YY HH:mm')
            })
            setAdjustedDocDetailForTable(docDetailForTable);
        }
    }, [isMobile, docDetailForTable]);

    const deleteDocumentDataPopupOpen = (data: dataConnectorList) => {
        // debugger;
        setDocumentSelected(data)
        setFlagDeleteDocumentDataPopup(true)
    }
    const deleteCancelDocumentDataPopupOpen = () => {
        setFlagDeleteDocumentDataPopup(false)

    }

    const rowClicked = async (e: any, rowDetail: any) => {
        if (e.iconKey !== "editIcon" && !isSystemApi(rowDetail?.chatbot_data_connector_function_path)) {
            navigate(`/customAPI/createCustomAPI?connector_id=${rowDetail.chatbot_data_connector_id}`)
        }
    }

    const handleDeleteDataConnector = async (data: any) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        let chatbot_id = searchParams.get('chatbot_id') ?? ""
        const response = await agent.deleteDataConnector.delete(data)
        if (response.status) {
            showSuccess("Data Connector Deleted Successfully!")
            await getChatbotDataConnectorListApiCall();
        } else {
            handleError(response);
        }
        deleteCancelDocumentDataPopupOpen()
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const handleRemoveDataConnectorAssignment = async () => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        if(documentSelected){
            const data_connector_assignement_id = documentSelected.data_connector_assignment?.find((assignment: DataConnectorAssignment) => assignment.data_connector_assignment_unique_id == Number(chatbotId))?.data_connector_assignment_id || 1;
            const res = await removeDataConnectorAssignment(data_connector_assignement_id);
            if(res.status){
                showSuccess("Custom API Removed Successfully")
                await getChatbotDataConnectorListApiCall();
            } else{
                handleError(res);
            }
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const menuItems = [

        // { label: 'Delete', icon: <img src={deleteDoc} alt="delete" />, action: (e: any) => deleteDocumentDataPopupOpen(e) },
        { label: 'Remove', icon: <img src={deleteDoc} alt="delete" />, action: (e: dataConnectorList) => deleteDocumentDataPopupOpen(e) },
    ];

    const innerHeight = (window.innerHeight - 190);
    
    return (
        <>
            {/* {flagDeleteDocumentDataPopup &&
                <GlobalPopUp
                    open={flagDeleteDocumentDataPopup}
                    titlePadding='0px'
                    onClose={() => { setFlagDeleteDocumentDataPopup(false) }}
                    handleClose={() => { setFlagDeleteDocumentDataPopup(false) }}
                >
                    <DeleteDocumentDataComponent
                        documentSelected={documentSelected != null && documentSelected.chatbot_data_connector_id}
                        deleteCancelDocumentDataPopupOpen={deleteCancelDocumentDataPopupOpen}
                        handleDeleteDocument={handleDeleteDataConnector}
                        deleteDescription="Are you sure you want to delete this Data Connector?" />
                </GlobalPopUp>
            } */}

            {flagDeleteDocumentDataPopup && 
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to remove the "${documentSelected?.data_connector_functions?.data_connector_function_name}" custom API`}
                    open={flagDeleteDocumentDataPopup}
                    onClose={() => {
                        setFlagDeleteDocumentDataPopup(false)
                    }}
                    onDelete={() => {
                        handleRemoveDataConnectorAssignment();
                        setFlagDeleteDocumentDataPopup(false)
                    }}
                />
            } 

            {flagAssignDataConnectorPopup &&  
                <Grid item className={globalStyles.fullwidth}>
                    <GlobalPopUp
                        open={flagAssignDataConnectorPopup}
                        onClose={() => { setFlagAssignDataConnectorPopup(false) }}
                        flagBackdrop
                        paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                        paperMaxwidth={flagSmallScreen ? "610px" : "700px"}
                        flagShowCloseIcon={true}
                        handleClose={() => { setFlagAssignDataConnectorPopup(false) }}
                        borderRadius='10px'
                        titlePadding='0px'
                    >
                        <AssignDataConnectorPopup
                            getChatbotDataConnectorListApiCall={getChatbotDataConnectorListApiCall} 
                            setFlagAssignDataConnectorPopup={setFlagAssignDataConnectorPopup}
                        />
                    </GlobalPopUp>
                </Grid>
            }

            <Grid item xl={12} xs={12} className={`${globalStyles.fullwidth} 
         
             `} sx={{ width: "100%", paddingTop: "20px" }}>
                <Grid container alignItems={"center"} justifyContent={"end"} >
                    {/* ${globalStyles.dashboardChildWrapper}
                 ${styles.dataConnectorDashboard} */}

                    {/* title header */}

                    {/* <Grid item xs={12}>
                        <Grid container xs={12} sx={{ alignItems: "center" }}>
                            <Grid item sx={{ marginBottom: "10px" }}>
                                <GlobalPageHeaderText
                                    mainHeadText={
                                        <Grid item xs={6}>
                                            <Autocomplete
                                                disableClearable
                                                value={chatBotDetails?.chatbot_name}
                                                className={styles.chatbotTitleSelect}
                                                options={chatbotList ? chatbotList.map((chatbot: any)=>chatbot.chatbot_name) : []}
                                                onChange={(e, value)=>handleOptionChange(value)}
                                                renderInput={(params: any) => <TextField
                                                    {...params} placeholder='Select' />}
                                            />
                                            
                                        </Grid>
                                    }
                                    mainSubText={
                                        <Breadcrumbs
                                            aria-label="breadcrumb"
                                            className={styles.cbHeaderBreadCrumb}
                                            sx={{
                                                '& .MuiBreadcrumbs-separator': {
                                                    marginRight: '3px',
                                                    marginLeft: '3px'
                                                }
                                            }}
                                        >
                                            <Link
                                                underline="hover"
                                                onClick={() => { navigate("/chatbot") }}
                                                // href="/dashboard/chatbot"
                                                className={`${styles.cbHeaderBreadCrumbsHeadText} ${globalStyles.clickable}`}
                                            >
                                                AI Chatbot
                                            </Link>
                                            <Link
                                                underline="hover"
                                                onClick={() => { navigate(`/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbotId}`) }}
                                                // href="/"
                                                className={`${styles.cbHeaderBreadCrumbsHeadText} ${globalStyles.clickable}`}

                                            >
                                                {chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot"}
                                            </Link>
                                            <Link
                                                underline="hover"
                                                // href="/"
                                                className={`${styles.cbHeaderBreadCrumbsChatbotLabel} ${globalStyles.clickable}`}

                                            >
                                                Data Connectors
                                            </Link>
                                        </Breadcrumbs>
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Divider style={{ width: "100%", opacity: "0.8", marginBlock: "15px" }} /> */}

                    <Grid item xs={12} className={`${globalStyles.globalHeadRightSubItem} ${styles.globalAddConnectorButton}`}>
                        <Grid container sx={{ alignItems: "center" }} justifyContent={"end"}>
                            {window.screen.width >= 900 &&
                                <Grid item className={`${globalStyles.globalNewAddBtnItem}`} sx={{ textAlign: "end" }}>
                                    {/* <Button
                                        variant='outlined'
                                        size='large'
                                        fullWidth
                                        sx={{ maxWidth: "130px" }}
                                        // startIcon={<img src={createPersonaIcon} alt="" style={{ height: "18px", width: 'auto' }} />}
                                        startIcon={<IconsColor iconName="plusIcon" width={"16"} height={"16"} fill={"#FFF"} />}
                                        className={styles.newConnectorBtn}
                                        onClick={() => { navigate(`/chatbot/viewchatbot/integration/createCustomAPI${window.location.search}`) }}
                                    >
                                        Assign
                                    </Button> */}
                                    <GlobalButton
                                        buttonText="Assign"
                                        startIcon={<AddIcon />}
                                        className='primaryButtonStyle' 
                                        sx={{width: "120px"}}
                                        onClick={() => setFlagAssignDataConnectorPopup(true)}
                                    />
                                </Grid>
                            }
                            {window.screen.width <= 899 &&
                                <IconButton
                                    className={`${globalStyles.cmpGlobalMobileAddIcon}`}
                                    onClick={() => { setFlagAssignDataConnectorPopup(true) }}
                                >
                                    <AddIcon />
                                </IconButton>
                            }
                        </Grid>
                    </Grid>

                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${styles.documentsTableItem}`} mt={2} height={`${innerHeight}px !important`}>
                        {flagRenderData == true ?
                            (
                                <GlobalTable
                                    headerList={adjustedHeaderList}
                                    rowData={dataConnectorList}
                                    tableHeight={"76vh"}
                                    // tableContainerHeight={"calc(100vh - 210px)"}
                                    tableContainerMinHeight={"auto"}
                                    onCellClick={(e: any, rowDetail: any) => { rowClicked(e, rowDetail) }}
                                    onRowClick={(e: any) => { console.log(e) }}
                                    deleteRowData={deleteDocumentDataPopupOpen}
                                    rowAllowEdit={rowAllowEdit}
                                    flagPagination
                                    menuItemsFromParent={menuItems}
                                // rowClicked={rowClicked}
                                />
                            ) : (<></>)
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default Dataconnector;
